import styled from 'styled-components'

const Img = styled.img`
  width: 100%;
  max-width: ${props => props.maxWidth || 200}px;
  height: auto;
`

export default Img
